export default __webpack_public_path__ + "static/media/leon_mdrrmc_responder.b79709e7.png";